import dayjs from "dayjs";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function ECDatePicker({ mode = "date", value, onChange, label, fullWidth, ...props }) {
  
  const getViews = () => {
    switch (mode) {
      case "month-year":
        return ["year", "month"];

      case "year":
        return ["year"];

      default:
        return ["year", "month", "day"];
    }
  };

  const getFormat = () => {
    switch (mode) {
      case "month-year":
        return "MM.YYYY";

      case "year":
        return "YYYY";

      default:
        return "DD.MM.YYYY";
    }
  };

  const formatValue = (date) => {
    if (!date) return null;

    switch (mode) {
      case "month-year":
        return date.format("YYYY-MM");

      case "year":
        return date.format("YYYY");

      default:
        return date.format("YYYY-MM-DD");
    }
  };

  return (
    <DatePicker
      label={label}
      views={getViews()}
      format={getFormat()}
      value={value ? dayjs(value) : null}
      onChange={(newValue) => {
        onChange(formatValue(newValue));
      }}
      slotProps={{
        textField: {
          fullWidth: fullWidth,
          InputLabelProps: {
            shrink: true,
          },
        },
      }}
      {...props}
    />
  );
}
